/** Fallbacks match _dashboard-chart-tokens.scss when DOM is not ready yet. */
const FALLBACK = {
    text: "#c2c2c2",
    gridSubtle: "rgba(255,255,255,0.06)",
    grid: "rgba(255,255,255,0.08)",
    seriesPrimaryFill: "rgba(232, 222, 22, 0.85)",
    seriesPrimaryStroke: "rgba(232, 222, 22, 1)",
    seriesSecondaryFill: "rgba(122, 231, 199, 0.85)",
    seriesTertiaryFill: "rgba(78, 89, 140, 0.85)",
    seriesTertiarySoft: "rgba(78, 89, 140, 0.75)",
    trendLine: "rgba(122, 231, 199, 1)",
    doughnutSlices: [
        "rgba(232, 222, 22, 0.9)",
        "rgba(122, 231, 199, 0.9)",
        "rgba(78, 89, 140, 0.9)",
        "rgba(213, 87, 59, 0.9)",
        "rgba(173, 216, 230, 0.9)",
        "rgba(255, 165, 0, 0.9)",
    ],
};

let cached = null;

function readVar(style, name, fallback) {
    const value = style.getPropertyValue(name).trim();
    return value || fallback;
}

/**
 * Read chart colors from .dashboard-wrapper CSS variables (Arnout: CSS as source of truth).
 * @param {Element | null | undefined} rootEl
 */
export function readDashboardChartColors(rootEl) {
    if (!rootEl) {
        return { ...FALLBACK, doughnutSlices: [...FALLBACK.doughnutSlices] };
    }
    const style = getComputedStyle(rootEl);
    cached = {
        text: readVar(style, "--dashboard-chart-text", FALLBACK.text),
        gridSubtle: readVar(style, "--dashboard-chart-grid-subtle", FALLBACK.gridSubtle),
        grid: readVar(style, "--dashboard-chart-grid", FALLBACK.grid),
        seriesPrimaryFill: readVar(style, "--dashboard-chart-series-primary-fill", FALLBACK.seriesPrimaryFill),
        seriesPrimaryStroke: readVar(style, "--dashboard-chart-series-primary-stroke", FALLBACK.seriesPrimaryStroke),
        seriesSecondaryFill: readVar(style, "--dashboard-chart-series-secondary-fill", FALLBACK.seriesSecondaryFill),
        seriesTertiaryFill: readVar(style, "--dashboard-chart-series-tertiary-fill", FALLBACK.seriesTertiaryFill),
        seriesTertiarySoft: readVar(style, "--dashboard-chart-series-tertiary-soft", FALLBACK.seriesTertiarySoft),
        trendLine: readVar(style, "--dashboard-chart-trend-line", FALLBACK.trendLine),
        doughnutSlices: [
            readVar(style, "--dashboard-chart-slice-1", FALLBACK.doughnutSlices[0]),
            readVar(style, "--dashboard-chart-slice-2", FALLBACK.doughnutSlices[1]),
            readVar(style, "--dashboard-chart-slice-3", FALLBACK.doughnutSlices[2]),
            readVar(style, "--dashboard-chart-slice-4", FALLBACK.doughnutSlices[3]),
            readVar(style, "--dashboard-chart-slice-5", FALLBACK.doughnutSlices[4]),
            readVar(style, "--dashboard-chart-slice-6", FALLBACK.doughnutSlices[5]),
        ],
    };
    return cached;
}

export function getDashboardChartColors() {
    if (cached) {
        return cached;
    }
    const root = typeof document !== "undefined" ? document.querySelector(".dashboard-wrapper") : null;
    return readDashboardChartColors(root);
}
